export default __webpack_public_path__ + "static/media/sliderMobile_6.215067e8.jpg";